import { FC, useEffect, useRef, useState } from 'react';
import { baseUrl } from 'utils';
import videojs from 'video.js';
import styles from './VideoPreview.module.scss';
import 'videojs-contrib-quality-levels';
import 'videojs-hls-quality-selector';
import '@silvermine/videojs-quality-selector';
import '@silvermine/videojs-quality-selector/dist/css/quality-selector.css';

import cn from 'classnames';

interface IVideoPreview {
  id: number;
  video_type: 'hls' | null;
}

const VideoPlayerHLS: FC<IVideoPreview> = ({ id, video_type }) => {
  const videoRef = useRef();
  const [player, setPlayer] = useState(undefined);
  const [userToken, setUserToken] = useState('');
  const userLanguage = localStorage.getItem('i18nextLng') || 'en-US';

  useEffect(() => {
    const getUserToken = JSON.parse(localStorage.getItem('authTokens')).access_token;
    setUserToken(getUserToken);
  }, []);

  const formatLanguage = (language: string) => {
    const languageArr = language.split('-');
    return languageArr[0];
  };

  const formattedLanguage = formatLanguage(userLanguage);

  const urlVideoHLS = `${baseUrl}/videos/streaming/${id}/${userToken}/main.m3u8?lang=${formattedLanguage}`;
  const urlVideoMP4 = `${baseUrl}/videos/preview/${id}?token=${userToken}`;

  useEffect(() => {
    if (player) {
      if (video_type === 'hls') {
        player.src({
          src: urlVideoHLS,
          type: 'application/x-mpegURL',
          withCredentials: false
        });
      } else {
        player.src([
          {
            src: `${urlVideoMP4}&resolution=1080`,
            type: 'video/mp4',
            label: '1080P',
            selected: true
          },
          {
            src: `${urlVideoMP4}&resolution=720`,
            type: 'video/mp4',
            label: '720P'
          },
          {
            src: `${urlVideoMP4}&resolution=540`,
            type: 'video/mp4',
            label: '540P'
          },
          {
            src: `${urlVideoMP4}&resolution=360`,
            type: 'video/mp4',
            label: '360P'
          }
        ]);
        player.controlBar.addChild('QualitySelector');
      }
    }
  }, [urlVideoHLS]);

  useEffect(() => {
    const videoJsOptions = {
      autoplay: true,
      preload: 'auto',

      controls: true
    };

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('@silvermine/videojs-quality-selector')(videojs);

    const p = videojs(videoRef.current, videoJsOptions);

    setPlayer(p);

    return () => {
      if (player) player.dispose();
    };
  }, []);

  useEffect(() => {
    if (player) {
      player.hlsQualitySelector({ displayCurrentQuality: true });
    }
  }, [player]);

  return (
    <div className={styles.video}>
      <video
        ref={videoRef}
        className={cn(
          styles.video,
          'vidPlayer',
          'video-js',
          'vjs-default-skin',
          'vjs-big-play-centered'
        )}
      ></video>
    </div>
  );
};
export const VideoPreview: FC<IVideoPreview> = ({ id, video_type }) => {
  const [userToken, setUserToken] = useState('');

  useEffect(() => {
    const getUserToken = JSON.parse(localStorage.getItem('authTokens')).access_token;
    setUserToken(getUserToken);
  }, []);

  return (
    <div className={styles.root}>
      {userToken && <VideoPlayerHLS id={id} video_type={video_type} />}
    </div>
  );
};
